import { FC } from 'react';
import { translate } from '../../i18n';
import { addPaymentMethodCardStyles } from './styles';
import { isDesktop } from '../../platform';
import plusAlt from '../../assets/icons/plusAlt.svg';

export interface AddPaymentMethodCardProps {
  /** ¿Está seleccionada dentro del carrusel? En web, sin seleccionar se muestra más baja. */
  isSelected?: boolean;
  onPress?: () => void;
  testID?: string;
  accessibilityLabel?: string;
}

/**
 * AddPaymentMethodCard — Botón para agregar nuevo método de pago
 *
 * Cambios:
 * ✅ Estilos centralizados en styles.ts
 * ✅ i18n para texto y aria-label
 * ✅ Cero Tailwind, cero hardcodes
 */
export const AddPaymentMethodCard: FC<AddPaymentMethodCardProps> = ({
  isSelected = true,
  onPress,
  testID = 'add-payment-method-card',
  accessibilityLabel = translate('paymentsUI.addPaymentCard.ariaLabel'),
}) => {
  return (
    <button
      onClick={onPress}
      disabled={!onPress}
      data-testid={testID}
      aria-label={accessibilityLabel}
      role="button"
      style={{
        ...addPaymentMethodCardStyles.button,
        ...(!onPress && addPaymentMethodCardStyles.buttonDisabled),
        ...(isDesktop && addPaymentMethodCardStyles.webButton),
        ...(isDesktop && !isSelected && addPaymentMethodCardStyles.webButtonCollapsed)
      }}
    >
      {
        isDesktop ? (
          <>
            <div style={addPaymentMethodCardStyles.cta}>
              <img src={plusAlt} />
              <span style={addPaymentMethodCardStyles.ctaText}>{translate('paymentsUI.web.addCard')}</span>
            </div>
            <p>{translate('paymentsUI.web.addCardSubtitle')}</p>
          </>
        ) : (
          <>
            {/* Plus Icon Box */}
            <div style={addPaymentMethodCardStyles.iconBox} data-testid={`${testID}-icon-box`}>
              <span style={addPaymentMethodCardStyles.icon}>+</span>
            </div>

            {/* Text */}
            <p style={addPaymentMethodCardStyles.text} data-testid={`${testID}-text`}>
              {translate('paymentsUI.addPaymentCard.title')}
            </p>
          </>
        )
      }
    </button>
  );
};
